"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M17.575 17.83L2.887 10.351c-.241-.123-.241-.323 0-.446l14.689-7.48a.936.936 0 0 1 .849 0l14.689 7.48c.241.123.241.323 0 .446L18.425 17.83a.936.936 0 0 1-.85 0zm15.539 8.075l-4.6-2.341L18.425 28.7a.936.936 0 0 1-.849 0L7.484 23.564l-4.6 2.341c-.241.123-.241.323 0 .446l14.691 7.479a.936.936 0 0 0 .849 0l14.689-7.479c.241-.123.241-.323.001-.446z" }),
  React.createElement("path", { d: "M33.114 17.905l-4.6-2.341L18.425 20.7a.936.936 0 0 1-.849 0L7.484 15.564l-4.6 2.341c-.241.123-.241.323 0 .446l14.691 7.479a.936.936 0 0 0 .849 0l14.689-7.479c.241-.123.241-.323.001-.446z" })
);

